export class Arena {
    id: number;
    name: string = '';
}


// WEBPACK FOOTER //
// ./src/model/arena.ts